/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Kind_DistributionInputs */



/**
* | output |
* | --- |
* | "Distribution" |
*
* @param {Promo_Ledger_Kind_DistributionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_kind_distribution = /** @type {((inputs?: Promo_Ledger_Kind_DistributionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Kind_DistributionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Distribution")
	if (locale === "es") return /** @type {LocalizedString} */ ("Distribución")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Distribuição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Distribuzione")
	return /** @type {LocalizedString} */ ("Distribution")
});